/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efc5fa277fbab89f379124dcf8d26bb8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { JiraServiceManagementLogo } from './logo';
export { JiraServiceManagementLogoCS } from './logo-cs';
export { JiraServiceManagementIcon } from './icon';
